import { BalloonContentType } from '@src/app/modules/map';

import { LoyaltyProgramProduct } from '../models';

/**
 * Утилита для получения меток на карте из продукта
 *
 * @param {LoyaltyProgramProduct} product Объект продукта
 * @param {string | undefined} unionId
 */
export const getBalloonContentByProduct = (
  product: LoyaltyProgramProduct,
  unionId?: string,
): Array<BalloonContentType> => {
  const link = '/loyalty/product/' + product.id + (unionId ? `?unionId=${unionId}` : '');

  return product.mapObjects.map(item => {
    return <BalloonContentType>{
      link,
      name: product.name,
      description: product.descriptionShort,
      address: item.address,
      geometry: {
        latitude: item.latitude,
        longitude: item.longitude,
      },
    };
  });
};
